<template>
  <div>
    <b-row
      class="content-header"
    >

      <!-- Content Left -->
      <b-col
        class="content-header-left mb-2"
        cols="12"
        md="12"
      >
        <b-row class="breadcrumbs-top">
          <b-col
            class="content-header-left mb-2"
            cols="12"
            md="12"
          >
            <b-row class="breadcrumbs-top">
              <b-col cols="12">
                <h1
                  class="custom-header-title"
                >
                  {{ request.stringID }} - {{ request.name }}
                </h1>
              </b-col>
            </b-row>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
    <section class="invoice-preview-wrapper">
      <b-row class="invoice-preview">
        <!-- Col: Left (Invoice Container) -->
        <!-- Right Col: Card -->
        <b-col
          cols="12"
          md="4"
          xl="3"
          class="invoice-actions user-request"
        >
          <div
            class="user_block ac_type mb-2"
            style="float: none;"
          >
            <div class="user_avatar" />
            <div class="user_info">
              <h6>Status</h6>
              <h5 class="text-capitalize">
                {{ request.status }}
              </h5>
            </div>
          </div>
          <div
            v-if="request.status == 'rejected'"
            class="reject_not"
          >
            <b-card class="mb-0">
              <template #header>
                <b-button
                  v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                  type="button"
                  variant="flat-primary"
                  class="mr-3"
                >
                  <feather-icon
                    icon="MessageSquareIcon"
                    class=""
                    size="20"
                  />
                </b-button>
                <h3 class="align-middle mr-auto">
                  Remarks
                </h3>
              </template>
              <b-card-text
                class="mb-0"
              >
                <strong>{{ request.approvedBy.name }} has rejected this User Request.</strong>
                <span class="notetext">
                  {{ request.adminRemarks }}
                </span>
              </b-card-text>
            </b-card>
          </div>

          <div
            v-if="request.status == 'action required'"
            class="reject_not"
          >
            <b-card class="mb-0">
              <template #header>
                <b-button
                  v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                  type="button"
                  variant="flat-primary"
                  class="mr-3"
                >
                  <feather-icon
                    icon="MessageSquareIcon"
                    class=""
                    size="20"
                  />
                </b-button>
                <h3 class="align-middle mr-auto">
                  Remarks
                </h3>
              </template>
              <b-card-text
                class="mb-0"
              >
                <strong>{{ request.approvedBy.name }} has send back this User Request.</strong>
                <span class="notetext">
                  {{ request.adminRemarks }}
                </span>
              </b-card-text>
            </b-card>
          </div>
          <b-card
            v-if="request.status == 'awaiting approval' && canViewThisAction('approve-user-creation', 'UserCreationRequest')"
            class="mb-0"
          >
            <template #header>
              <b-button
                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                type="button"
                variant="flat-primary"
                class="primary-button-with-background mr-3"
              >
                <feather-icon
                  icon="CheckCircleIcon"
                  class="white-color"
                  size="20"
                />
              </b-button>
              <h3 class="align-middle mr-auto">
                Ready to Approve?
              </h3>
            </template>
            <p>You may approve this user request if the information is accurate.</p>
            <hr>
            <b-form-checkbox
              v-model="secondAgree"
              value="accepted"
              unchecked-value=""
              class="custom-control-primary"
            >
              I have reviewed the details of this user request.
            </b-form-checkbox>

            <!-- Button: Send Invoice -->
            <b-button
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              variant="success"
              class="mb-75"
              block
              :disabled="secondAgree == '' || !canViewThisAction('approve', 'AgentRequest')"
              @click="approveRequest()"
            >
              <feather-icon
                icon="CheckIcon"
                class="mr-50"
                size="16"
              />
              <span class="align-middle">Approve</span>
            </b-button>
            <div class="d-flex justify-content-between">
              <b-button
                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                variant="flat-danger"
                class="mb-75 reject-btn"
                @click="rejectRequest()"
              >
                <feather-icon
                  icon="XIcon"
                  class="mr-50"
                  size="16"
                />
                <span class="align-middle">Reject</span>
              </b-button>
              <b-button
                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                variant="flat-primary"
                class="mb-75 send-back-btn"
                @click="sendBackRequest()"
              >
                <feather-icon
                  icon="SendIcon"
                  class="mr-50"
                  size="16"
                />
                <span class="align-middle">Send back</span>
              </b-button>
            </div>
          </b-card>
        </b-col>
        <b-col
          cols="12"
          xl="9"
          md="8"
        >
          <b-card
            no-body
            class="h-100"
            title="User Account Request Details"
          >
            <b-card-body>
              <b-row>
                <b-col
                  cols="12"
                  md="12"
                >
                  <div class="d-flex mb-2">
                    <b-card-title class="custom-header-title fs-21">
                      User Account Request Details
                    </b-card-title>
                    <b-button
                      v-if="request.status == 'awaiting approval' && canViewThisAction('request-user-creation', 'UserCreationRequest')"
                      variant="link"
                      class="btn-icon rounded-circle ml-auto mr-1 flat-primary-bg"
                      @click="openEditModal"
                    >
                      <feather-icon icon="EditIcon" /> Edit
                    </b-button>
                  </div>
                  <b-table-simple
                    borderless
                    responsive
                    class="particulars_of_deceased small-padding-table d-none d-md-block"
                  >
                    <b-tbody>
                      <b-tr>
                        <b-th>
                          Name
                        </b-th>
                        <b-td>
                          <span class="">{{ request.name || '-' }}</span>
                        </b-td>
                      </b-tr>
                      <b-tr>
                        <b-th>
                          Position
                        </b-th>
                        <b-td>
                          <span class="">{{ request.position || '-' }}</span>
                        </b-td>
                      </b-tr>
                      <b-tr>
                        <b-th>
                          Department
                        </b-th>
                        <b-td>
                          <span
                            v-for="(dept, key) in request.department"
                            :key="key"
                          >
                            {{ dept.name }}<span v-if="key < request.department.length - 1">, </span>
                          </span>
                        </b-td>
                      </b-tr>
                      <b-tr>
                        <b-th>
                          Email
                        </b-th>
                        <b-td>
                          <span class="">{{ request.email || '-' }}</span>
                        </b-td>
                      </b-tr>
                      <b-tr>
                        <b-th>
                          Roles
                        </b-th>
                        <b-td>
                          <b-badge
                            v-for="(roleVal, key) in request.roles"
                            :key="key"
                            variant="outline-primary"
                            class="mr-50"
                          >
                            {{ roleVal.role }}
                          </b-badge>
                        </b-td>
                      </b-tr>
                      <b-tr>
                        <b-th>
                          Remarks
                        </b-th>
                        <b-td>
                          <span class="">{{ request.remarks || '-' }}</span>
                        </b-td>
                      </b-tr>
                    </b-tbody>
                  </b-table-simple>
                </b-col>
              </b-row>
              <hr v-if="request.user">
              <b-row v-if="request.user">
                <b-col
                  cols="12"
                  md="12"
                >
                  <div class="d-flex mb-2">
                    <b-card-title class="custom-header-title fs-21 mt-1">
                      Existing User Details
                    </b-card-title>
                  </div>
                  <b-table-simple
                    borderless
                    responsive
                    class="particulars_of_deceased small-padding-table d-none d-md-block"
                  >
                    <b-tbody>
                      <b-tr>
                        <b-th>
                          Name
                        </b-th>
                        <b-td>
                          <span class="">{{ request.user.name || '-' }}</span>
                        </b-td>
                      </b-tr>
                      <b-tr>
                        <b-th>
                          Position
                        </b-th>
                        <b-td>
                          <span class="">{{ request.user.position || '-' }}</span>
                        </b-td>
                      </b-tr>
                      <b-tr>
                        <b-th>
                          Department
                        </b-th>
                        <b-td>
                          <span
                            v-for="(dept, key) in request.user.department"
                            :key="key"
                          >
                            {{ dept.name }}<span v-if="key < request.department.length - 1">, </span>
                          </span>
                        </b-td>
                      </b-tr>
                      <b-tr>
                        <b-th>
                          Email
                        </b-th>
                        <b-td>
                          <span class="">{{ request.user.email || '-' }}</span>
                        </b-td>
                      </b-tr>
                      <b-tr>
                        <b-th>
                          Roles
                        </b-th>
                        <b-td>
                          <b-badge
                            v-for="(roleVal, key) in request.user.roles"
                            :key="key"
                            variant="outline-primary"
                            class="mr-50"
                          >
                            {{ roleVal.role }}
                          </b-badge>
                        </b-td>
                      </b-tr>
                      <b-tr>
                        <b-th>
                          Remarks
                        </b-th>
                        <b-td>
                          <span class="">-</span>
                        </b-td>
                      </b-tr>
                    </b-tbody>
                  </b-table-simple>
                </b-col>
              </b-row>
            </b-card-body>
          </b-card>
        </b-col>
      </b-row>
    </section>

    <b-modal
      id="modal-update-agent"
      ref="update_user_modal"
      modal-class="status-update-modal iu-modal"
      footer-class="iu-edit-modal-footer"
      cancel-variant="flat-primary"
      ok-variant="primary"
      ok-title="Save Changes"
      cancel-title="Cancel"
      centered
      no-close-on-backdrop
      title="Edit"
      size="sm"
      @ok="submitEditForm"
    >
      <b-form @submit.prevent="submitEditForm">
        <validation-observer
          ref="requestEditForm"
        >
          <b-form-group
            label="Name*"
            label-for="h-iu-name"
          >
            <validation-provider
              #default="{ errors }"
              name="Name"
              vid="name"
              rules="required"
            >
              <b-form-input
                id="h-iu-name"
                v-model="name"
                placeholder="Name"
                name="name"
                :disabled="request.user != null"
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>
          <b-form-group
            label="Position*"
            label-for="h-user-position"
          >
            <validation-provider
              #default="{ errors }"
              name="Position"
              vid="position"
              rules="required"
            >
              <b-form-input
                id="h-user-position"
                v-model="position"
                placeholder="Manager"
                name="position"
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>
          <validation-provider
            #default="{ errors }"
            name="Department"
            vid="department"
            rules="required"
          >
            <b-form-group
              label="Department*"
              label-for="h-iu-department"
            >
              <v-select
                id="h-iu-department"
                v-model="department"
                label="name"
                :options="departmentOptions"
                :reduce="name => name._id"
                :clearable="false"
                placeholder="Choose a Department"
                multiple
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </b-form-group>
          </validation-provider>

          <b-form-group
            label="Email*"
            label-for="h-user-email"
          >
            <validation-provider
              #default="{ errors }"
              name="Email"
              vid="email"
              rules="required|email"
            >
              <b-form-input
                id="h-user-email"
                v-model="email"
                placeholder="Email"
                name="email"
                :disabled="request.user != null"
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>
          <validation-provider
            #default="{ errors }"
            name="Role"
            vid="role"
            rules="required"
          >
            <b-form-group
              label="Roles*"
              label-for="h-iu-role"
            >
              <v-select
                id="h-iu-role"
                v-model="selectedRoles"
                label="role"
                :options="compRoleOptions"
                :clearable="false"
                placeholder="Choose a role"
                multiple
                @input="updateRoles"
              >
                <template #option="{ _id, role, description }">
                  <span :class="{ 'text-primary': !roles.includes(_id) }">{{ role }}</span>
                  <br>
                  <span class="fs-12">{{ description }}</span>
                </template>
              </v-select>
              <small class="text-danger">{{ errors[0] }}</small>
            </b-form-group>
          </validation-provider>
        </validation-observer>
      </b-form>
      <template #modal-footer="{ ok, cancel }">
        <b-button
          variant="outline-primary"
          @click="cancel()"
        >
          Cancel
        </b-button>
        <b-button
          variant="primary"
          @click="ok()"
        >
          <span class="align-middle">Save Changes</span>
        </b-button>
      </template>
    </b-modal>
  </div>
</template>

<script>
import { ValidationObserver, ValidationProvider } from 'vee-validate'
import {
  BCard, BRow, BButton, BCol, BTableSimple, BTr, BTh, BTd, BTbody, VBTooltip, BForm, BBadge,
  BCardText, BFormCheckbox, BCardBody, BCardTitle, BFormGroup, BFormInput,
} from 'bootstrap-vue'
import { required } from '@validations'
import Ripple from 'vue-ripple-directive'
import { useUtils as useAclUtils } from '@/libs/acl/custom'
import store from '@/store/index'
import vSelect from 'vue-select'
// eslint-disable-next-line import/no-extraneous-dependencies
import 'cleave.js/dist/addons/cleave-phone.us'

import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

const { canViewThisAction } = useAclUtils()

export default {
  components: {
    BCard,
    BRow,
    BButton,
    BCol,
    BTableSimple,
    BTr,
    BTd,
    BTh,
    BTbody,
    BCardText,
    BFormCheckbox,
    BCardBody,
    BCardTitle,
    BFormGroup,
    BFormInput,
    BForm,
    BBadge,
    vSelect,
    ValidationObserver,
    ValidationProvider,
  },
  directives: {
    'b-tooltip': VBTooltip,
    Ripple,
  },
  data() {
    return {
      canViewThisAction,
      user: store.state.auth.userData,
      rejectNote: '',
      secondAgree: '',
      name: '',
      position: '',
      email: '',
      department: [],
      roles: [],
      selectedRoles: [],
      required,

      request: {},
      departmentOptions: [],
      roleOptions: [],
    }
  },
  computed: {
    compRoleOptions() {
      if (!this.department.length) return []
      return this.roleOptions.filter(role => this.department.some(dep => role.departments.includes(dep)))
    },
  },
  created() {
    this.$http.get('directory/users/respond-with/extra-options')
      .then(response => {
        this.roleOptions = response.data.roleOptions ?? []
        this.departmentOptions = response.data.departments
        this.getRoles()
      })
      .catch(error => {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: error.data.message ?? process.env.VUE_APP_DEFAULT_ERROR_MESSAGE,
            icon: 'AlertTriangleIcon',
            variant: 'danger',
          },
        })
      })
    this.$http.get(`directory/users/requests/${this.$route.params.id}/show`)
      .then(response => {
        this.request = response.data
        this.email = this.request.email
        this.position = this.request.position
        this.name = this.request.name
        this.department = this.request.department.map(dep => dep._id)
        this.roles = this.request.roles.map(role => role._id)
        this.getRoles()
      })
      .catch(error => {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: error.data.message || process.env.VUE_APP_DEFAULT_ERROR_MESSAGE,
            icon: 'AlertTriangleIcon',
            variant: 'danger',
          },
        })
      })
  },
  methods: {
    getRoles() {
      this.roles.forEach(role => {
        const roleData = this.roleOptions.find(o => String(o._id) === role)
        if (roleData) {
          this.selectedRoles.push(roleData)
        }
      })
    },
    updateRoles(selected) {
      this.selectedRoles = selected
      this.roles = selected.map(role => role._id)
      if (this.roleValidation) this.roleValidation = false
    },
    approveRequest() {
      this.$swal({
        title: 'Approve this User Request?',
        html: '<br>You are going to approve this User Request. Are you sure?',
        // eslint-disable-next-line global-require
        imageUrl: require('@/assets/images/icons/success.png'),
        reverseButtons: true,
        showCancelButton: true,
        cancelButtonText: 'No, go back',
        confirmButtonText: 'Yes, proceed',
        customClass: {
          confirmButton: 'btn btn-primary ml-1',
          cancelButton: 'btn btn-outline-primary',
        },
        buttonsStyling: false,
      })
        .then(result => {
          if (result.value) {
            const formData = new FormData()
            formData.append('url', window.location.origin)

            this.$http.post(`directory/users/requests/${this.$route.params.id}/approve`, formData, {
              headers: { 'Content-Type': 'multipart/form-data' },
            })
              .then(response => {
                this.request.status = response.data.data.status
                this.$swal({
                  title: 'Request approved',
                  html: '',
                  // eslint-disable-next-line global-require
                  imageUrl: require('@/assets/images/icons/success.png'),
                  imageWidth: 80,
                  imageHeight: 80,
                  imageAlt: 'Custom Icon',
                  showCancelButton: false,
                  confirmButtonText: 'Okay',
                  customClass: {
                    confirmButton: 'btn btn-primary mt-1',
                  },
                  buttonsStyling: false,
                })
              })
              .catch(error => {
                this.$toast({
                  component: ToastificationContent,
                  props: {
                    title: error.data.message || process.env.VUE_APP_DEFAULT_ERROR_MESSAGE,
                    icon: 'AlertTriangleIcon',
                    variant: 'danger',
                  },
                })
              })
          }
        })
    },

    rejectRequest() {
      this.$swal({
        title: 'Are you sure you want to reject this request?',
        html: `<br>Once you reject this request <strong>${this.request.stringID}, <br> ${this.request.createdBy.name}</strong> will be informed.`,
        // eslint-disable-next-line global-require
        imageUrl: require('@/assets/images/icons/file-cross.png'),
        input: 'textarea',
        inputPlaceholder: 'Add Remarks',
        imageWidth: 80,
        imageHeight: 80,
        imageAlt: 'Custom Icon',
        reverseButtons: true,
        showCancelButton: true,
        confirmButtonText: 'Yes, reject request',
        cancelButtonText: 'No, go back',
        customClass: {
          confirmButton: 'btn btn-primary ml-1',
          cancelButton: 'btn btn-outline-primary',
          input: 'reject-note-ta',
        },
        buttonsStyling: false,
        preConfirm: inputValue => {
          const textarea = this.$swal.getInput()
          const errorContainer = document.getElementById('swal-validation-error')

          if (!inputValue || inputValue.trim() === '') {
            textarea.classList.add('swal-input-error')
            if (!errorContainer) {
              const errorEl = document.createElement('small')
              errorEl.id = 'swal-validation-error'
              errorEl.innerText = 'Remarks are required to reject the request.'
              textarea.parentNode.appendChild(errorEl)
            }
            return false
          }

          // Cleanup if valid
          textarea.classList.remove('swal-input-error')
          if (errorContainer) errorContainer.remove()

          return inputValue
        },
        didOpen: () => {
          const textarea = this.$swal.getInput()
          textarea.classList.remove('swal-input-error')
        },
      })
        .then(result => {
          if (result.value) {
            const formData = new FormData()
            formData.append('remarks', result.value)
            formData.append('url', window.location.origin)

            this.$http.post(`directory/users/requests/${this.$route.params.id}/reject`, formData, {
              headers: { 'Content-Type': 'multipart/form-data' },
            })
              .then(response => {
                this.request = response.data.data
                this.$swal({
                  title: 'Request rejected',
                  html: '',
                  // eslint-disable-next-line global-require
                  imageUrl: require('@/assets/images/icons/success.png'),
                  imageWidth: 80,
                  imageHeight: 80,
                  imageAlt: 'Custom Icon',
                  showCancelButton: false,
                  confirmButtonText: 'Okay',
                  customClass: {
                    confirmButton: 'btn btn-primary mt-1',
                  },
                  buttonsStyling: false,
                })
              })
              .catch(error => {
                this.$toast({
                  component: ToastificationContent,
                  props: {
                    title: error.data.message || process.env.VUE_APP_DEFAULT_ERROR_MESSAGE,
                    icon: 'AlertTriangleIcon',
                    variant: 'danger',
                  },
                })
              })
          } else if (result.dismiss !== 'cancel') {
            this.$toast({
              component: ToastificationContent,
              props: {
                title: 'Please provide your remarks',
                icon: 'AlertTriangleIcon',
                variant: 'danger',
              },
            })
          }
        })
    },
    sendBackRequest() {
      this.$swal({
        title: 'Send this request back to head of department',
        html: `<br><strong>${this.request.createdBy.name}</strong> will be notified if you return this to the HOD to make the necessary changes. Please provide your remarks below.`,
        // eslint-disable-next-line global-require
        imageUrl: require('@/assets/images/icons/fly-blue.png'),
        input: 'textarea',
        inputPlaceholder: 'Add Remarks',
        imageWidth: 80,
        imageHeight: 80,
        imageAlt: 'Custom Icon',
        reverseButtons: true,
        showCancelButton: true,
        confirmButtonText: 'Send back to HOD',
        cancelButtonText: 'Cancel',
        customClass: {
          confirmButton: 'btn btn-primary ml-1',
          cancelButton: 'btn btn-outline-primary',
          input: 'reject-note-ta',
        },
        buttonsStyling: false,
      })
        .then(result => {
          if (result.value) {
            const formData = new FormData()
            formData.append('remarks', result.value)
            formData.append('url', window.location.origin)

            this.$http.post(`directory/users/requests/${this.$route.params.id}/send-back`, formData, {
              headers: { 'Content-Type': 'multipart/form-data' },
            })
              .then(response => {
                this.request = response.data.data
                this.$swal({
                  title: 'Request sent back to HOD',
                  html: '',
                  // eslint-disable-next-line global-require
                  imageUrl: require('@/assets/images/icons/success.png'),
                  imageWidth: 80,
                  imageHeight: 80,
                  imageAlt: 'Custom Icon',
                  showCancelButton: false,
                  confirmButtonText: 'Okay',
                  customClass: {
                    confirmButton: 'btn btn-primary mt-1',
                  },
                  buttonsStyling: false,
                })
              })
              .catch(error => {
                this.$toast({
                  component: ToastificationContent,
                  props: {
                    title: error.data.message || process.env.VUE_APP_DEFAULT_ERROR_MESSAGE,
                    icon: 'AlertTriangleIcon',
                    variant: 'danger',
                  },
                })
              })
          } else if (result.dismiss !== 'cancel') {
            this.$toast({
              component: ToastificationContent,
              props: {
                title: 'Please provide your remarks',
                icon: 'AlertTriangleIcon',
                variant: 'danger',
              },
            })
          }
        })
    },
    resolveAcronymName(name) {
      return name.split(' ').map(item => item.charAt(0)).join('').toUpperCase()
    },

    updateChange(status) {
      let title = ''
      if (status === 'approved') {
        title = 'Change Approved'
      } else {
        title = 'Change Rejected'
      }
      const formData = new FormData()
      formData.append('status', status)
      formData.append('rejectNote', this.rejectNote)

      this.$http.post(`customer/agent/profile-change/${this.$route.params.id}/approve`, formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
      })
        .then(response => {
          this.request = response.data.data
          this.$swal({
            title,
            html: '',
            // eslint-disable-next-line global-require
            imageUrl: require('@/assets/images/icons/success.png'),
            imageWidth: 80,
            imageHeight: 80,
            imageAlt: 'Custom Icon',
            showCancelButton: false,
            confirmButtonText: 'Okay',
            customClass: {
              confirmButton: 'btn btn-primary',
            },
            buttonsStyling: false,
          })
        })
        .catch(error => {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: error.data.message || process.env.VUE_APP_DEFAULT_ERROR_MESSAGE,
              icon: 'AlertTriangleIcon',
              variant: 'danger',
            },
          })
        })
    },

    async openEditModal() {
      this.$refs.update_user_modal.show()
      await this.$nextTick()
      this.email = this.request.email
      this.position = this.request.position
      this.name = this.request.name
      this.department = this.request.department.map(dep => dep._id)
      this.roles = this.request.roles.map(role => role._id)
    },
    submitEditForm(bvModalEvt) {
      bvModalEvt.preventDefault()
      this.$refs.requestEditForm.validate().then(success => {
        if (success) {
          this.$refs.update_user_modal.hide()
          this.$swal({
            title: 'Save current changes?',
            html: 'Your changes will overwrite the current information, are you sure?',
            // eslint-disable-next-line global-require
            imageUrl: require('@/assets/images/icons/warning.png'),
            imageWidth: 80,
            imageHeight: 80,
            imageAlt: 'Custom Icon',
            reverseButtons: true,
            showCancelButton: true,
            confirmButtonText: 'Yes, Save Changes',
            cancelButtonText: 'No, go back',
            customClass: {
              confirmButton: 'btn btn-primary ml-1',
              cancelButton: 'btn btn-outline-primary',
            },
            buttonsStyling: false,
          })
            .then(result => {
              if (result.value) {
                const formData = new FormData()
                formData.append('name', this.name)
                formData.append('position', this.position)
                formData.append('email', this.email)
                // eslint-disable-next-line no-plusplus
                for (let i = 0; i < this.department.length; i++) {
                  formData.append('department[]', this.department[i])
                }
                // eslint-disable-next-line no-plusplus
                for (let i = 0; i < this.roles.length; i++) {
                  formData.append('roles[]', this.roles[i])
                }

                this.$http.post(`directory/users/requests/${this.$route.params.id}/overwrite`, formData, {
                  headers: { 'Content-Type': 'multipart/form-data' },
                })
                  .then(response => {
                    if (response.data.success) {
                      this.request = response.data.data
                      this.$swal({
                        title: 'Changes Saved',
                        html: '',
                        // eslint-disable-next-line global-require
                        imageUrl: require('@/assets/images/icons/success.png'),
                        imageWidth: 80,
                        imageHeight: 80,
                        imageAlt: 'Custom Icon',
                        showCancelButton: false,
                        confirmButtonText: 'Okay',
                        customClass: {
                          confirmButton: 'btn btn-primary mt-1',
                        },
                        buttonsStyling: false,
                      })
                    } else {
                      this.$toast({
                        component: ToastificationContent,
                        props: {
                          title: response.data.message || process.env.VUE_APP_DEFAULT_ERROR_MESSAGE,
                          icon: 'AlertTriangleIcon',
                          variant: 'danger',
                        },
                      })
                    }
                  })
                  .catch(error => {
                    this.$toast({
                      component: ToastificationContent,
                      props: {
                        title: error.data.message || process.env.VUE_APP_DEFAULT_ERROR_MESSAGE,
                        icon: 'AlertTriangleIcon',
                        variant: 'danger',
                      },
                    })
                  })
              }
            })
        }
      })
    },
  },
}
</script>

<style lang="scss">
  .per-page-selector {
    width: 90px;
  }
  .badge.light-font {
    font-weight: 400;
  }
  .modal-header.payment-status.front-modal {
    background: #21BB8B;
    padding: 24px 30px !important;
    button {
      background: rgba(255, 255, 255, 0.3) !important;
      margin-right: 20px !important;
      padding: 0;
      border-radius: 5px;
      min-width: 40px;
      width: 40px;
      line-height: 40px;
      height: 40px;
      position: relative;
    }
    h3 {
      font-size: 18px;
      line-height: 21px;
      color: #fff;
    }
    span.step-class {
      color: #fff !important;
      font-weight: 500;
      text-transform: uppercase;
      line-height: 23px;
      font-size: 12px;
      display: block;
    }
    .feather {
      vertical-align: text-bottom;
      color: #fff;
    }
  }
  .btn-success-without-button {
    border-color: #21BB8B !important;
    background-color: #21BB8B !important;
    color: #fff;
    &:hover {
      color: #fff;
    }
  }
  .invoice-actions.user-request svg.feather.feather-send {
    color: #104D9D;
  }
  .badge-outline-primary {
    border: 1px solid #D2DCEA;
    background-color: #FFF;
    color: #333333;
    font-weight: 400;
    font-size: 14px;
    line-height: 20px;
    letter-spacing: 0px;
  }
  .btn.send-back-btn {
    margin-right: 1.5rem !important;
    padding: 0.786rem 0.5rem !important;
  }
  .btn.reject-btn {
    margin-left: 1.5rem !important;
    padding: 0.786rem 0.5rem !important;
  }
</style>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
